import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileCallBar } from "./MobileCallBar";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Header />
      <main className="flex-1">{children}</main>
      <div className="pb-14 lg:pb-0 bg-foreground">
        <Footer />
      </div>
      <MobileCallBar />
    </div>
  );
}
